<div class="cx-modal-container">
    <div class="cx-modal-content">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <span>{{ 'quoteTracking.rejection' | cxTranslate }}</span>
        </div>
      </div>
      <div class="cx-dialog-body modal-body">
        <div class="row">
          <div class="cx-dialog-info col-md-12">
            <p>
              {{ 'quoteTracking.rejection2' | cxTranslate }}
            </p>
          </div>
          <div class="col-md-8">
            <div
              *ngIf="reasonsForRejection$ | async as reasonsForRejection"
              class="vs-text-field"
            >
              <label
                ><span class="required">*</span>
                {{ 'quoteTracking.rejection' | cxTranslate }}</label
              >
              <select
                [(ngModel)]="reasonForRejection"
                [ngClass]="
                  isSumbitted &&
                  (!reasonForRejection ||
                    reasonForRejection === '' ||
                    reasonForRejection === 'Select')
                    ? 'error-select'
                    : ''
                "
              >
                <option value="" selected hidden disabled>
                  {{ 'quoteTracking.selectPlaceholder' | cxTranslate }}
                </option>
                <option
                  *ngFor="let reason of reasonsForRejection.rejectType"
                  [value]="reason.rejectCode"
                >
                  {{ reason.rejectDesc }}
                </option>
              </select>
              <label
                *ngIf="
                  isSumbitted &&
                  (!reasonForRejection ||
                    reasonForRejection === 'Select' ||
                    reasonForRejection === '')
                "
                class="error"
                >{{ 'quoteTracking.rejection3' | cxTranslate }}</label
              >
            </div>
          </div>
          <div class="col-md-12">
            <div class="vs-text-field space-top">
              <label>{{ 'quoteTracking.comments' | cxTranslate }}</label>
              <textarea [(ngModel)]="comments" maxlength="100"></textarea>
              <label *ngIf="isSumbitted && isComment" class="error">
                {{ 'quoteTracking.enterDescription' | cxTranslate }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 reject-btn">
            <button
              cxAutoFocus
              class="vs-primary-btn"
              (click)="closeModal(reasonForRejection, comments)"
            >
              {{ 'quoteTracking.reject' | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  